export default __webpack_public_path__ + "static/media/Save to CRM.e279b541.png";